module.exports = __webpack_public_path__ + "static/media/partner8.1b5feecd.jpg";